<template>
  <div>
    <div class="layout">
      <md-card class="card">
        <h3>BALANCE</h3>
        <md-card-content class="content">
          <span>${{ currentUser.walletBalance }}</span>
          <md-avatar class="md-avatar-icon">
            <md-icon>attach_money</md-icon></md-avatar
          >
        </md-card-content>
        <router-link class="color" to="/account/withdrawal">WITHDRAW</router-link>
      </md-card>

      <md-card class="card">
        <h3>DEPOSITS</h3>
        <md-card-content class="content">
          <span>${{ currentUser.totalDeposit }}</span>
          <md-avatar class="md-avatar-icon">
            <md-icon>attach_money</md-icon></md-avatar
          >
        </md-card-content>

        <router-link to="/account/deposit">DEPOSIT NOW</router-link>
      </md-card>

      <md-card class="card">
        <h3>PROFITS</h3>
        <md-card-content class="content">
          <span>${{ currentUser.totalProfit }}</span>
          <md-avatar class="md-avatar-icon">
            <md-icon>attach_money</md-icon></md-avatar
          >
        </md-card-content>
        <router-link class="yellow" to="/account/transaction">HISTORY</router-link>
      </md-card>

      <div class="chart">
        <coingecko-coin-ticker-widget  coin-id="bitcoin" currency="usd" locale="en" background-color="#ffffff">
        </coingecko-coin-ticker-widget>
      </div>

      <div class="others">
        <div
          class="MuiGrid-root MuiGrid-container MuiGrid-spacing-xs-2 MuiGrid-align-items-xs-center MuiGrid-justify-xs-center "
        >
          <div
            class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12 MuiGrid-grid-sm-6 MuiGrid-grid-md-4 other-lay"
          >
            <div
              id="id-overview-widget"
              class="tradingview-widget-container"
              style="width: 100%; height: 450px;"
            >
              <iframe
                scrolling="no"
                allowtransparency="true"
                frameborder="0"
                src="https://s.tradingview.com/embed-widget/market-overview/?locale=en#%7B%22colorTheme%22%3A%22light%22%2C%22dateRange%22%3A%221D%22%2C%22showChart%22%3Atrue%2C%22largeChartUrl%22%3A%22%22%2C%22isTransparent%22%3Afalse%2C%22height%22%3A%22450%22%2C%22width%22%3A%22100%25%22%2C%22plotLineColorGrowing%22%3A%22rgba(33%2C%20150%2C%20243%2C%201)%22%2C%22plotLineColorFalling%22%3A%22rgba(33%2C%20150%2C%20243%2C%201)%22%2C%22gridLineColor%22%3A%22rgba(240%2C%20243%2C%20250%2C%201)%22%2C%22scaleFontColor%22%3A%22rgba(120%2C%20123%2C%20134%2C%201)%22%2C%22belowLineFillColorGrowing%22%3A%22rgba(33%2C%20150%2C%20243%2C%200.12)%22%2C%22belowLineFillColorFalling%22%3A%22rgba(33%2C%20150%2C%20243%2C%200.12)%22%2C%22symbolActiveColor%22%3A%22rgba(33%2C%20150%2C%20243%2C%200.12)%22%2C%22tabs%22%3A%5B%7B%22title%22%3A%22Cryptocurrencies%22%2C%22symbols%22%3A%5B%7B%22s%22%3A%22BITSTAMP%3ABTCUSD%22%7D%2C%7B%22s%22%3A%22COINBASE%3AETHUSD%22%7D%2C%7B%22s%22%3A%22COINBASE%3AALGOUSD%22%7D%2C%7B%22s%22%3A%22BINANCE%3ABNBBTC%22%7D%2C%7B%22s%22%3A%22BITSTAMP%3AXRPUSD%22%7D%2C%7B%22s%22%3A%22COINBASE%3ALTCUSD%22%7D%5D%7D%2C%7B%22title%22%3A%22Commodities%22%2C%22symbols%22%3A%5B%7B%22s%22%3A%22CME_MINI%3AES1!%22%2C%22d%22%3A%22E-Mini%20S%26P%22%7D%2C%7B%22s%22%3A%22CME%3A6E1!%22%2C%22d%22%3A%22Euro%22%7D%2C%7B%22s%22%3A%22COMEX%3AGC1!%22%2C%22d%22%3A%22Gold%22%7D%2C%7B%22s%22%3A%22NYMEX%3ACL1!%22%2C%22d%22%3A%22Crude%20Oil%22%7D%2C%7B%22s%22%3A%22NYMEX%3ANG1!%22%2C%22d%22%3A%22Natural%20Gas%22%7D%2C%7B%22s%22%3A%22CBOT%3AZC1!%22%2C%22d%22%3A%22Corn%22%7D%5D%2C%22originalTitle%22%3A%22Commodities%22%7D%2C%7B%22title%22%3A%22Bonds%22%2C%22symbols%22%3A%5B%7B%22s%22%3A%22CME%3AGE1!%22%2C%22d%22%3A%22Eurodollar%22%7D%2C%7B%22s%22%3A%22CBOT%3AZB1!%22%2C%22d%22%3A%22T-Bond%22%7D%2C%7B%22s%22%3A%22CBOT%3AUB1!%22%2C%22d%22%3A%22Ultra%20T-Bond%22%7D%2C%7B%22s%22%3A%22EUREX%3AFGBL1!%22%2C%22d%22%3A%22Euro%20Bund%22%7D%2C%7B%22s%22%3A%22EUREX%3AFBTP1!%22%2C%22d%22%3A%22Euro%20BTP%22%7D%2C%7B%22s%22%3A%22EUREX%3AFGBM1!%22%2C%22d%22%3A%22Euro%20BOBL%22%7D%5D%2C%22originalTitle%22%3A%22Bonds%22%7D%2C%7B%22title%22%3A%22Forex%22%2C%22symbols%22%3A%5B%7B%22s%22%3A%22FX%3AEURUSD%22%7D%2C%7B%22s%22%3A%22FX%3AGBPUSD%22%7D%2C%7B%22s%22%3A%22FX%3AUSDJPY%22%7D%2C%7B%22s%22%3A%22FX%3AUSDCHF%22%7D%2C%7B%22s%22%3A%22FX%3AAUDUSD%22%7D%2C%7B%22s%22%3A%22FX%3AUSDCAD%22%7D%5D%2C%22originalTitle%22%3A%22Forex%22%7D%5D%2C%22utm_source%22%3A%22binaryiqtrade.com%22%2C%22utm_medium%22%3A%22widget%22%2C%22utm_campaign%22%3A%22market-overview%22%7D"
                style="box-sizing: border-box; height: 450px; width: 100%;"
              ></iframe>
            </div>

            <div
              id="make-it-rain"
              class="tradingview-widget-container"
              style="width: 100%; height: 450px;"
            >
              <iframe
                scrolling="no"
                allowtransparency="true"
                frameborder="0"
                src="https://s.tradingview.com/embed-widget/technical-analysis/?locale=en#%7B%22interval%22%3A%221m%22%2C%22width%22%3A%22100%25%22%2C%22isTransparent%22%3Afalse%2C%22height%22%3A450%2C%22symbol%22%3A%22BITSTAMP%3ABTCUSD%22%2C%22showIntervalTabs%22%3Atrue%2C%22colorTheme%22%3A%22light%22%2C%22utm_source%22%3A%22binaryiqtrade.com%22%2C%22utm_medium%22%3A%22widget%22%2C%22utm_campaign%22%3A%22technical-analysis%22%7D"
                style="box-sizing: border-box; height: 450px; width: 100%;"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Dashboard',

  computed: {
    ...mapGetters(['currentUser']),
  },
};
</script>

<style scoped>
.layout {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
}

.color {
  background-color: green !important;
}

.yellow {
  background-color: rgb(255, 183, 0) !important;
}

.card {
  color: #fff;
  padding: 24px;
  position: relative;
  align-items: center;
  background-color: #3f51b5;
}

.content {
  display: flex;
  justify-content: space-between;
}

.card h3 {
  font-size: 0.75rem;
  font-family: 'Roboto';
  font-weight: 400;
  line-height: 2.66;
  text-transform: uppercase;
  margin: 0;
}

.card span {
  font-size: 2.25rem;
  font-family: 'Fira Code';
  font-weight: 400;
  line-height: 1.167;
  letter-spacing: 0em;
}

.card .content {
  padding: 0;
}

.md-avatar-icon {
  margin: 0;
  background-color: #fff !important;
}

.md-avatar-icon * {
  color: #f50057 !important;
}

.card a {
  right: 20%;
  bottom: 5px;
  position: absolute;
  font-size: 10px !important;
  color: #fff;
  background-color: #f50057;

  box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%),
    0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);

  padding: 6px 16px;
  font-size: 0.875rem;
  min-width: 64px;
  box-sizing: border-box;
  transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
    box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
    border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  font-family: 'Roboto';
  font-weight: 500;
  line-height: 1.75;
  border-radius: 4px;
  text-transform: uppercase;
}

.chart {
  grid-column: 1/4;
}

.other-lay {
  display: flex;

  width: 60%;
  margin: 0 auto;
}

.other-lay > div {
  margin: 0 1rem;
}

.others {
  grid-column: 1/4;
}

@media (max-width: 600px) {
  .layout {
    display: flex;
    flex-direction: column;
  }
  .card {
    margin: 0.5rem;
  }

  .other-lay {
    flex-direction: column-reverse;
    width: 100%;
    margin: 0 auto;
  }

  .other-lay > div {
    margin: 0;
  }

  .dash-div {
    width: 85%;
  }
}
</style>
